// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Seychelles */
const SC = /^(?:2[125-8]\d{5})$/;

export default SC;
